import { typedStyles } from '@/utils/styleUtils';

export const styles = typedStyles({
  modal: {
    top: 80,
    transform: 'translateX(-50%)',
  },

  body: {
    display: 'flex',
    width: 480,
    minHeight: 724,
    flexDirection: 'column',
    overflowY: 'auto',
  },

  fields: ({ spacing }) => ({
    padding: spacing(8, 6, 4),
    flex: 1,
  }),

  header: {
    marginBottom: 4,
  },

  switchField: ({ spacing }) => ({
    margin: spacing(3, 0, 1),
  }),

  switchLabel: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  permissionsError: {
    marginTop: 2.5,
  },

  actionIcon: {
    fontSize: 48,
    marginBottom: 2,
  },

  paddingEnd: {
    marginInline: -10,
  },

  editIcon: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },

  memberDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: -4,
  },
  memberTable: {
    paddingTop: 2,
    marginLeft: '-48px',
    width: '126%',
  },

  paddingTop: {
    paddingTop: 2,
  },

  infoBox: {
    gap: 1.25,
    padding: 2.5,
    flexDirection: 'column',
  },
  boxGrid: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    alignItems: 'center',
    marginBottom: 3.5,
    columnGap: 2,
  },
  marginBottom: {
    marginBottom: 3.5,
  },
  minHeight: { minHeight: 405 },
});
